/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API48224Req {
  
  /** 任务id */
  taskId?: number;
  /** 评级(1~5) */
  evaluateLevel?: number;
  /** 评价内容 */
  evaluate?: string;
};



export interface API48224Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 48224 评价任务

export interface IUsePostAPI48224Return {
  /** 评价任务: 接口请求状态 */
  isAPI48224Loading: boolean;
  /** 评价任务: 接口请求返回数据 */
  dataAPI48224: API48224Res;
  /**  评价任务: 接口数据请求方法 */
  fetchAPI48224Data:  (inputs: API48224Req, config?: YWRequestConfig) => Promise<API48224Res>;
  /** 评价任务: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI48224 = ():IUsePostAPI48224Return => {
  let isMount = true;
  const [isAPI48224Loading, setIsAPI48224Loading] = useState(false);
  const [dataAPI48224, setDataAPI48224] = useState<API48224Res>({} as API48224Res);
  const requestUrl = `${basePath}/team-work/workTask/evaluateWorkTask`;

  const fetchAPI48224Data = async (inputs: API48224Req, config?: YWRequestConfig): Promise<API48224Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48224Req>) || {}) as API48224Req;
    
  
    if ( isMount ) {
      setIsAPI48224Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API48224Res>(`${basePath}/team-work/workTask/evaluateWorkTask`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI48224(res || {} as API48224Res);
        setIsAPI48224Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48224Loading(false);
      }
      return false as unknown as API48224Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48224Loading,
    dataAPI48224,
    fetchAPI48224Data,
    requestUrl,
  }
}

